export * from './getWorkspaceQuizLock';
export * from './postWorkspaceQuizLock';
export * from './putWorkspaceQuizLock';
